import { AppointmentProduct } from 'kb-shared/types';

export const getAppointmentType = (product?: AppointmentProduct) => {
  if (product?.type === 'appointment') {
    return product.data;
  }

  return null;
};
